import { WarningIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Flex,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  VStack,
} from '@chakra-ui/react'
import type { ReactNode } from 'react'

interface DeactivateLocationPopoverProps {
  locationName: string
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  onConfirm: () => void
  children: ReactNode
}

export const DeactivateLocationPopover = ({
  locationName,
  isOpen,
  onOpen,
  onClose,
  onConfirm,
  children,
}: DeactivateLocationPopoverProps) => {
  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-end">
      <PopoverTrigger>
        <Box>{children}</Box>
      </PopoverTrigger>
      <PopoverContent
        borderRadius="xl"
        boxShadow="lg"
        border="1px"
        borderColor="gray.200"
        p={4}
        w="280px"
      >
        <PopoverArrow />
        <PopoverBody p={0}>
          <VStack align="stretch" spacing={3}>
            <HStack spacing={3} align="flex-start">
              <Flex
                bg="red.50"
                borderRadius="full"
                p={2}
                align="center"
                justify="center"
                flexShrink={0}
              >
                <WarningIcon color="red.500" boxSize={4} />
              </Flex>
              <Text fontWeight="bold" fontSize="md" color="gray.900" lineHeight="1.4" pt={1}>
                Deactivate location?
              </Text>
            </HStack>

            <Text fontSize="sm" color="gray.600" lineHeight="1.5">
              <Text as="span" fontWeight="bold">
                {locationName}
              </Text>{' '}
              will be marked inactive. Prescribers will no longer be able to select it as a work
              location.
            </Text>

            <HStack spacing={2} justify="flex-end" pt={1}>
              <Button
                size="sm"
                variant="outline"
                borderColor="gray.200"
                color="gray.700"
                bg="white"
                _hover={{ bg: 'gray.50' }}
                onClick={onClose}
                minW="70px"
              >
                Cancel
              </Button>
              <Button
                size="sm"
                bg="red.600"
                color="white"
                _hover={{ bg: 'red.700' }}
                onClick={onConfirm}
                minW="120px"
              >
                Yes, deactivate
              </Button>
            </HStack>
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
